<mat-tab-group>

    <!-- TAB 1 - EDIT STALL DETAILS -->
    <mat-tab label="Stall Details">

        <form [formGroup]="StallForm" class="p-4">

            <div class="row mb-4">
                <div class="col-9">
                    <mat-label>Select Image</mat-label>
                    <div class="input-group">
                        <input type="file" class="form-control" #file accept="image/*"
                            (change)="previewpimage(file.files)">
                    </div>
                </div>

                <div class="col-3">
                    <div *ngIf="!isOld1">
                        <img [src]="'https://aieventzo.com/upload/' + event_id + '/stall/' + imagePath"
                            style="width: 80px; height: 80px; border-radius: 10px;">
                    </div>
                    <div *ngIf="isOld1">
                        <img [src]="'https://aieventzo.com/upload/' + event_id + '/stall/' + image_name"
                            style="width: 80px; height: 80px; border-radius: 10px;">
                    </div>
                </div>
            </div>

            <div class="column">
                <mat-form-field appearance="outline">
                    <mat-label>Owner Name</mat-label>
                    <input matInput formControlName="owner_name" readonly>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Owner Number</mat-label>
                    <input type="number" matInput formControlName="owner_number" readonly>
                </mat-form-field>
            </div>

            <div class="column">
                <mat-form-field appearance="outline">
                    <mat-label>Stall Number</mat-label>
                    <input matInput formControlName="stall_num" readonly>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Company Name</mat-label>
                    <input matInput formControlName="company_name">
                </mat-form-field>
            </div>

            <div class="col-md-6 mb-3">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Address</mat-label>
                    <input matInput formControlName="address" placeholder="Enter address" />
                    <mat-hint align="end">
                        {{ StallForm.get('address')?.value?.length || 0 }}/250
                    </mat-hint>
                </mat-form-field>
            </div>

            <div class="column">
                <mat-form-field appearance="outline">
                    <mat-label>Website</mat-label>
                    <input matInput formControlName="website" />
                    <mat-hint align="end">
                        {{ StallForm.get('website')?.value?.length || 0 }}/250
                    </mat-hint>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Youtube</mat-label>
                    <input matInput formControlName="youtube">
                    <mat-hint align="end">
                        {{ StallForm.get('youtube')?.value?.length || 0 }}/250
                    </mat-hint>
                </mat-form-field>
            </div>

            <div class="column">
                <mat-form-field appearance="outline">
                    <mat-label>Facebook</mat-label>
                    <input matInput formControlName="facebook">
                    <mat-hint align="end">
                        {{ StallForm.get('facebook')?.value?.length || 0 }}/250
                    </mat-hint>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Instagram</mat-label>
                    <input matInput formControlName="instagram">
                    <mat-hint align="end">
                        {{ StallForm.get('instagram')?.value?.length || 0 }}/250
                    </mat-hint>
                </mat-form-field>
            </div>

            <div class="column">
                <mat-form-field appearance="outline">
                    <mat-label>Notes</mat-label>
                    <textarea matInput formControlName="notes"></textarea>
                </mat-form-field>
            </div>

            <div align="end">
                <button mat-raised-button color="primary" routerLink="/My Stall" class="me-2">CANCEL</button>
                <button mat-raised-button color="accent" (click)="onFormSubmit()">SAVE</button>
            </div>

        </form>

    </mat-tab>

    <!-- TAB 2 - CATEGORY -->
    <mat-tab label="Category">
        <app-stall-category [so_id]="so_id"></app-stall-category>
    </mat-tab>

    <!-- TAB 3 - PRODUCTS -->
    <mat-tab label="Products">
        <app-stall-product [so_id]="so_id"></app-stall-product>
    </mat-tab>

</mat-tab-group>